import { useContext, useEffect } from "react";
import { ReactFlowProvider } from "@xyflow/react";
import { StoreContext } from "../store/Store";
import { Layout } from "./Layout";
import { actionTypes } from "../store/storeTypes";
// import allData from "../data/cayman3sep.json";
import allData from "../data/changerequestSept27.json";

export const Provider = ({ mode }) => {
  const [store, dispatch] = useContext(StoreContext);
  const { entityData, menuSelection, selectedCountry } = store;

  useEffect(() => {
    const newData = {};
    allData.forEach((item, i) => {
      if (item.Country in newData) {
        if (item.Panel in newData[item.Country]) {
          newData[item.Country][item.Panel].push({ ...item, order: i });
        } else {
          newData[item.Country][item.Panel] = [{ ...item, order: i }];
        }
      } else {
        newData[item.Country] = { [item.Panel]: [{ ...item, order: i }] };
      }
    });

    dispatch({ type: actionTypes.SET_ENTITY_DATA, payload: newData });
  }, [dispatch]);

  useEffect(() => {
    if (
      selectedCountry &&
      menuSelection &&
      entityData &&
      menuSelection !== "Select Country"
    ) {
      if (menuSelection in entityData[selectedCountry]) {
        const selectedData = entityData[selectedCountry][menuSelection].sort(
          (a, b) => {
            return a.order < b.order ? 1 : a.order < b.order ? -1 : 0;
          }
        );
        dispatch({
          type: actionTypes.SET_COUNTRY_DATA,
          payload: selectedData,
        });
      } else {
        dispatch({
          type: actionTypes.SET_COUNTRY_DATA,
          payload: null,
        });
        dispatch({
          type: actionTypes.SET_NODES,
          payload: [],
        });
        dispatch({
          type: actionTypes.SET_EDGES,
          payload: [],
        });
      }
    }
  }, [selectedCountry, menuSelection, dispatch, entityData, mode]);

  useEffect(() => {
    //set mode
    dispatch({ type: actionTypes.SET_MODE, payload: mode });
  }, [dispatch, mode]);

  return mode ? (
    <ReactFlowProvider>
      <Layout />
    </ReactFlowProvider>
  ) : null;
};
